import { defineMessages } from 'react-intl';

export const membershipTypeMessages = defineMessages({
    membershipTemplates: {
        id: 'membership-templates',
        defaultMessage: 'Membership templates',
    },
    memberships: {
        id: 'memberships',
        defaultMessage: 'Memberships',
    },
    templates: {
        id: 'templates',
        defaultMessage: 'Templates',
    },
    template: {
        id: 'template',
        defaultMessage: 'Template',
    },
    custom: {
        id: 'custom',
        defaultMessage: 'Custom',
    },
    priced: {
        id: 'priced',
        defaultMessage: 'Priced',
    },
    createTemplateSuccess: {
        id: 'create-template-success',
        defaultMessage: 'Template created',
    },
    createTemplateSuccessDescription: {
        id: 'create-template-success-description',
        defaultMessage: 'A new membership template has been successfully created.',
    },
    addTemplateModalSubtitle: {
        id: 'add-template-modal-subtitle',
        defaultMessage: 'Add a new membership template',
    },
    hasPricingPlan: {
        id: 'has-pricing-plan',
        defaultMessage: 'Has pricing plan',
    },
    applyPricingPerSpace: {
        id: 'apply-pricing-per-space',
        defaultMessage: 'Apply pricing per space',
    },
    autoRenew: {
        id: 'auto-renew',
        defaultMessage: 'Auto renew',
    },
    limitDuration: {
        id: 'limit-duration',
        defaultMessage: 'Limit duration',
    },
    customDuration: {
        id: 'custom-duration',
        defaultMessage: 'Custom duration',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    durationUnit: {
        id: 'duration-unit',
        defaultMessage: 'Duration unit',
    },
    extraVisitors: {
        id: 'extra-visitors',
        defaultMessage: 'Extra visitors',
    },
    maxExtraVisitors: {
        id: 'max-extra-visitors',
        defaultMessage: 'Max extra visitors',
    },
    maxAllowedSpaces: {
        id: 'max-allowed-spaces',
        defaultMessage: 'Max allowed spaces',
    },
    customSpaceCount: {
        id: 'custom-space-count',
        defaultMessage: 'Custom space count',
    },
    limitSpaces: {
        id: 'limit-spaces',
        defaultMessage: 'Limit spaces',
    },
    allowAccessOverCapacityLimit: {
        id: 'allow-access-over-capacity-limit',
        defaultMessage: 'Allow access over capacity limit',
    },
    allowAccessAsClientOutsideRestrictions: {
        id: 'allow-access-as-client-outside-restrictions',
        defaultMessage: 'Allow access as client outside restrictions',
    },
    contributeToAvailableSpaces: {
        id: 'contribute-to-available-spaces',
        defaultMessage: 'Contribute to available spaces',
    },
    limitToRoles: {
        id: 'limit-to-roles',
        defaultMessage: 'Limit to roles',
    },
    templateDashboard: {
        id: 'template-dashboard',
        defaultMessage: '{template} dashboard',
    },
    membershipTemplateDashboard: {
        id: 'membership-template-dashboard',
        defaultMessage: 'Template dashboard',
    },
    activeTemplate: {
        id: 'active-template',
        defaultMessage: 'Active',
    },
    inactiveTemplate: {
        id: 'inactive-template',
        defaultMessage: 'Inactive',
    },
    activateTemplate: {
        id: 'activate-template',
        defaultMessage: 'Activate',
    },
    pricedPerSpace: {
        id: 'priced-per-space',
        defaultMessage: 'Priced per space',
    },
    allowCustomDuration: {
        id: 'allow-custom-duration',
        defaultMessage: 'Allow custom duration',
    },
    nameBg: {
        id: 'name-bg',
        defaultMessage: 'Name (BG)',
    },
    nameEn: {
        id: 'name-en',
        defaultMessage: 'Name (EN)',
    },
    descriptionBg: {
        id: 'description-bg',
        defaultMessage: 'Description (BG)',
    },
    descriptionEn: {
        id: 'description-en',
        defaultMessage: 'Description (EN)',
    },
    deleteTemplateSuccess: {
        id: 'delete-template-success',
        defaultMessage: 'Template deleted',
    },
    deleteTemplateSuccessDescription: {
        id: 'delete-template-success-description',
        defaultMessage: 'Template {entry} has been successfully deleted.',
    },
    deleteTemplate: {
        id: 'delete-template',
        defaultMessage: 'Delete template',
    },
    deleteTemplateSubtitle: {
        id: 'delete-template-subtitle',
        defaultMessage: 'Permanently delete template {entry}',
    },
    confirmDeleteTemplate: {
        id: 'confirm-delete-template',
        defaultMessage: 'Are you sure you want to delete template {entry}? This action cannot be undone.',
    },
    activateTemplateModal: {
        id: 'activate-template-modal',
        defaultMessage: 'Activate template',
    },
    activateTemplateSubtitle: {
        id: 'activate-template-subtitle',
        defaultMessage: 'Activate template {entry}',
    },
    activatedTemplateSuccess: {
        id: 'activated-template-success',
        defaultMessage: 'Template activated',
    },
    activatedTemplateSuccessDescription: {
        id: 'activated-template-success-description',
        defaultMessage: 'Template {entry} has been successfully activated.',
    },
    confirmActivateTemplate: {
        id: 'confirm-activate-template',
        defaultMessage: 'Are you sure you want to activate template {entry}?',
    },
    editTemplate: {
        id: 'edit-template',
        defaultMessage: 'Edit template',
    },
    editTemplateSubtitle: {
        id: 'edit-template-subtitle',
        defaultMessage: 'Edit template {entry}',
    },
    updateTemplateSuccess: {
        id: 'update-template-success',
        defaultMessage: 'Template updated',
    },
    updateTemplateSuccessDescription: {
        id: 'update-template-success-description',
        defaultMessage: 'Template {entry} has been successfully updated.',
    },
    timeRestriction: {
        id: 'time-restriction',
        defaultMessage: 'Time restriction',
    },
    membershipDuration: {
        id: 'membership-duration',
        defaultMessage: 'Duration',
    },
    typeCreatedAt: {
        id: 'type-created-at',
        defaultMessage: 'Created at',
    },
    typeModifiedAt: {
        id: 'type-modified-at',
        defaultMessage: 'Modified at',
    },
    deactivateTemplate: {
        id: 'deactivate-template',
        defaultMessage: 'Deactivate',
    },
    deactivateTemplateModal: {
        id: 'deactivate-template-modal',
        defaultMessage: 'Deactivate template',
    },
    deactivateTemplateSubtitle: {
        id: 'deactivate-template-subtitle',
        defaultMessage: 'Deactivate template {entry}',
    },
    deactivatedTemplateSuccess: {
        id: 'deactivated-template-success',
        defaultMessage: 'Template deactivated',
    },
    deactivatedTemplateSuccessDescription: {
        id: 'deactivated-template-success-description',
        defaultMessage: 'Template {entry} has been successfully deactivated.',
    },
    confirmDeactivateTemplate: {
        id: 'confirm-deactivate-template',
        defaultMessage: 'Are you sure you want to deactivate template {entry}?',
    },
    isSystem: {
        id: 'is-system',
        defaultMessage: 'System',
    },
    copyMembershipTemplateSubtitle: {
        id: 'copy-membership-template-subtitle',
        defaultMessage: 'Copy membership template {entry}',
    },
    copyMembershipTemplateSuccess: {
        id: 'copy-membership-template-success',
        defaultMessage: 'Membership template copied',
    },
    copyMembershipTemplateSuccessDescription: {
        id: 'copy-membership-template-success-description',
        defaultMessage: 'Membership template {entry} has been successfully copied.',
    },
    requiredRecords: {
        id: 'required-records',
        defaultMessage: '{count} of {totalCount} required records',
    },
    requiredRecordsToResolve: {
        id: 'required-records-to-resolve',
        defaultMessage:
            '{count, plural, =0 {# items} one {# item} other {# items}} to resolve before it works as intended.',
    },
    notConfiguredProperly: {
        id: 'not-configured-properly',
        defaultMessage: 'This template is not configured properly',
    },
    fullyConfigured: {
        id: 'fully-configured',
        defaultMessage: 'This template is fully configured',
    },
    fullyConfiguredDescription: {
        id: 'fully-configured-description',
        defaultMessage: 'All required records are in place.',
    },
    required: {
        id: 'required',
        defaultMessage: 'Required',
    },
    optional: {
        id: 'optional',
        defaultMessage: 'Optional',
    },
    configure: {
        id: 'configure',
        defaultMessage: 'Configure',
    },
    totalAllowedTimes: {
        id: 'total-allowed-times',
        defaultMessage: '{count} time windows',
    },
    pluralRules: {
        id: 'plural-rules',
        defaultMessage: '{value, plural, =0 {# rules} one {# rule} other {# rules}}',
    },
    zoneRulesSpaces: {
        id: 'zone-rules-spaces',
        defaultMessage: '{value} spaces',
    },
    allGatewaysAllowed: {
        id: 'all-gateways-allowed',
        defaultMessage: 'All gateways allowed',
    },
    restrictedGatewaysCount: {
        id: 'restricted-gateways-count',
        defaultMessage: '{count} restricted gateways',
    },
    pluralRestrictedGatewaysCount: {
        id: 'plural-restricted-gateways-count',
        defaultMessage:
            '{value, plural, =0 {# restricted gateways} one {# restricted gateway} other {# restricted gateways}}',
    },
    pricingPlanRequirement: {
        id: 'pricing-plan-requirement',
        defaultMessage: 'The plan used to charge members for their stays.',
    },
    allowedTimesRequirement: {
        id: 'allowed-times-requirement',
        defaultMessage:
            'Days and hours the membership is valid. With none, the membership is never valid and entry is refused.',
    },
    restrictedGatewaysRequirement: {
        id: 'restricted-gateways-requirement',
        defaultMessage: 'Optional. Restrict entry to specific barriers, each with its own pricing plan.',
    },
    zoneRulesRequirement: {
        id: 'zone-rules-requirement',
        defaultMessage:
            'Which zones members can enter and how many spaces each reserves. Reserved spaces must total the max allowed spaces ({count}).',
    },
    zoneRulesRequirementCustomSpace: {
        id: 'zone-rules-requirement-custom-space',
        defaultMessage:
            'Not defined here - because "Custom space count" is on, each membership sets its own zones and per-zone space limits.',
    },
    setPerMembership: {
        id: 'set-per-membership',
        defaultMessage: 'Set per membership',
    },
    noLimits: {
        id: 'no-limits',
        defaultMessage: 'No limits',
    },
    activeMembershipTypeProtectedError: {
        id: 'custom-error:active_membership_type_protected',
        defaultMessage: 'Active membership types and their related entities cannot be modified or deleted!',
    },
    customTimeRestriction: {
        id: 'custom-time-restriction',
        defaultMessage: 'Custom time restriction',
    },
    allowedTimesRequirementOptional: {
        id: 'allowed-times-requirement-optional',
        defaultMessage: 'Days and hours the membership is valid.',
    },
});

export const restrictedGatewayMessages = defineMessages({
    gateway: {
        id: 'gateway',
        defaultMessage: 'Gateway',
    },
    gatewayPoint: {
        id: 'gateway-point',
        defaultMessage: 'Gateway',
    },
    gateways: {
        id: 'gateways',
        defaultMessage: 'Gateways',
    },
    restrictedGateway: {
        id: 'restricted-gateway',
        defaultMessage: 'Restricted gateway',
    },
    restrictedGateways: {
        id: 'restricted-gateways',
        defaultMessage: 'Restricted gateways',
    },
    entryZone: {
        id: 'entry-zone',
        defaultMessage: 'Entry zone',
    },
    exitZone: {
        id: 'exit-zone',
        defaultMessage: 'Exit zone',
    },
    addRestrictedGatewayModalSubtitle: {
        id: 'add-restricted-gateway-modal-subtitle',
        defaultMessage: 'Add a new restricted gateway',
    },
    createRestrictedGatewaySuccess: {
        id: 'create-restricted-gateway-success',
        defaultMessage: 'Restricted gateway created',
    },
    createRestrictedGatewaySuccessDescription: {
        id: 'create-restricted-gateway-success-description',
        defaultMessage: 'Restricted gateway has been successfully created.',
    },
    deleteRestrictedGateway: {
        id: 'delete-restricted-gateway',
        defaultMessage: 'Delete restricted gateway',
    },
    deleteRestrictedGatewaySubtitle: {
        id: 'delete-restricted-gateway-subtitle',
        defaultMessage: 'Permanently delete restricted gateway {entry}',
    },
    confirmDeleteRestrictedGateway: {
        id: 'confirm-delete-restricted-gateway',
        defaultMessage: 'Are you sure you want to delete restricted gateway {entry}? This action cannot be undone.',
    },
    deleteRestrictedGatewaySuccess: {
        id: 'delete-restricted-gateway-success',
        defaultMessage: 'Restricted gateway deleted',
    },
    deleteRestrictedGatewaySuccessDescription: {
        id: 'delete-restricted-gateway-success-description',
        defaultMessage: 'Restricted gateway {entry} has been successfully deleted.',
    },
    inheritedRestrictedGateways: {
        id: 'inherited-restricted-gateways',
        defaultMessage: 'Restricted gateways - inherited from {entry}',
    },
});

export const zoneRulesMessages = defineMessages({
    zoneRules: {
        id: 'zone-rules',
        defaultMessage: 'Zone rules',
    },
    zoneRule: {
        id: 'zone-rule',
        defaultMessage: 'Rule',
    },
    rules: {
        id: 'rules',
        defaultMessage: 'Rules',
    },
    rule: {
        id: 'rule',
        defaultMessage: 'Rule',
    },
    transitTime: {
        id: 'transit-time',
        defaultMessage: 'Transit time',
    },
    transitTimeInMinutes: {
        id: 'transit-time-in-minutes',
        defaultMessage: 'Transit time in minutes',
    },
    reserveSpaces: {
        id: 'reserve-spaces',
        defaultMessage: 'Reserve spaces',
    },
    createZoneRuleSuccess: {
        id: 'create-zone-rule-success',
        defaultMessage: 'Zone rule created',
    },
    createZoneRuleSuccessDescription: {
        id: 'create-zone-rule-success-description',
        defaultMessage: 'A new zone rule has been successfully created.',
    },
    addZoneRuleModalSubtitle: {
        id: 'add-zone-rule-modal-subtitle',
        defaultMessage: 'Add a new zone rule',
    },
    allowedExtraVisitorsTime: {
        id: 'allowed-extra-visitors-time',
        defaultMessage: 'Allowed extra visitors time',
    },
    allowedExtraVisitorsTimeInMinutes: {
        id: 'allowed-extra-visitors-time-in-minutes',
        defaultMessage: 'Allowed extra visitors time in minutes',
    },
    allowedSpacesCount: {
        id: 'allowed-spaces-count',
        defaultMessage: 'Allowed spaces',
    },
    deleteZoneRuleSuccessDescription: {
        id: 'delete-zone-rule-success-description',
        defaultMessage: 'Zone rule for {entry} has been successfully deleted.',
    },
    deleteZoneRule: {
        id: 'delete-zone-rule',
        defaultMessage: 'Delete zone rule',
    },
    deleteZoneRuleSubtitle: {
        id: 'delete-zone-rule-subtitle',
        defaultMessage: 'Permanently delete zone rule for {entry}',
    },
    confirmDeleteZoneRule: {
        id: 'confirm-delete-zone-rule',
        defaultMessage: 'Are you sure you want to delete zone rule for {entry}? This action cannot be undone.',
    },
    deleteZoneRuleSuccess: {
        id: 'delete-zone-rile-success',
        defaultMessage: 'Zone rule deleted',
    },
    updateZoneRuleSuccess: {
        id: 'update-zone-rule-success',
        defaultMessage: 'Zone rule updated',
    },
    updateZoneRuleSuccessDescription: {
        id: 'update-zone-rule-success-description',
        defaultMessage: 'Rule for {entry} has been successfully updated.',
    },
    editZoneRuleSubtitle: {
        id: 'edit-zone-rule-subtitle',
        defaultMessage: 'Edit rule for {entry}',
    },
    zoneRulesCanNotBeDefined: {
        id: 'zone-rules-can-not-be-defined',
        defaultMessage: 'Zone rules can not be defined in this template',
    },
    zoneRulesCanNotBeDefinedSubtitle: {
        id: 'zone-rules-can-not-be-defined-subtitle',
        defaultMessage:
            'You have selected "Custom space count" to be Yes, and therefore the rules for each zone are to be individually defined in each membership.',
    },
    inheritedZoneRules: {
        id: 'inherited-zone-rules',
        defaultMessage: 'Zone rules - inherited from {entry}',
    },
});

export const allowedTimesMessages = defineMessages({
    dayOfWeek: {
        id: 'day-of-week',
        defaultMessage: 'Day of week',
    },
    allowedTime: {
        id: 'allowed-time',
        defaultMessage: 'Allowed time',
    },
    time: {
        id: 'time',
        defaultMessage: 'Time',
    },
    times: {
        id: 'times',
        defaultMessage: 'Times',
    },
    from: {
        id: 'from',
        defaultMessage: 'From',
    },
    to: {
        id: 'to',
        defaultMessage: 'To',
    },
    addAllowedTimeModalSubtitle: {
        id: 'add-allowed-time-modal-subtitle',
        defaultMessage: 'Add a new allowed time',
    },
    createAllowedTimeSuccess: {
        id: 'create-allowed-time-success',
        defaultMessage: 'Allowed time created',
    },
    createAllowedTimeSuccessDescription: {
        id: 'create-allowed-time-success-description',
        defaultMessage: 'Allowed time has been successfully created.',
    },
    deleteAllowedTimeSuccessDescription: {
        id: 'delete-allowed-time-success-description',
        defaultMessage: 'Allowed time for {entry} has been successfully deleted.',
    },
    deleteAllowedTime: {
        id: 'delete-allowed-time',
        defaultMessage: 'Delete allowed time',
    },
    deleteAllowedTimeSubtitle: {
        id: 'delete-allowed-time-subtitle',
        defaultMessage: 'Permanently delete allowed time for {entry}',
    },
    confirmDeleteAllowedTime: {
        id: 'confirm-delete-allowed-time',
        defaultMessage: 'Are you sure you want to delete allowed time for {entry}? This action cannot be undone.',
    },
    deleteAllowedTimeSuccess: {
        id: 'delete-allowed-time-success',
        defaultMessage: 'Allowed time deleted',
    },
    updateAllowedTimeSuccess: {
        id: 'update-allowed-time-success',
        defaultMessage: 'Allowed time updated',
    },
    updateAllowedTimeSuccessDescription: {
        id: 'update-allowed-time-success-description',
        defaultMessage: 'Allowed time for {entry} has been successfully updated.',
    },
    editAllowedTimeSubtitle: {
        id: 'edit-allowed-time-subtitle',
        defaultMessage: 'Edit allowed time for {entry}',
    },
    inheritedAllowedTime: {
        id: 'inherited-allowed-time',
        defaultMessage: 'Allowed time - inherited from {entry}',
    },
});
